__turbopack_context__.v({
  "categoryBlock": "WineCategoryBlocks-module-scss-module__LAbq7G__categoryBlock",
  "categoryImage": "WineCategoryBlocks-module-scss-module__LAbq7G__categoryImage",
  "categoryLink": "WineCategoryBlocks-module-scss-module__LAbq7G__categoryLink",
  "categoryTitle": "WineCategoryBlocks-module-scss-module__LAbq7G__categoryTitle",
  "imageContainer": "WineCategoryBlocks-module-scss-module__LAbq7G__imageContainer",
  "menuCategorySection": "WineCategoryBlocks-module-scss-module__LAbq7G__menuCategorySection",
  "overlay": "WineCategoryBlocks-module-scss-module__LAbq7G__overlay",
});
